import Vue from 'vue';
import Qs from 'qs';
import store from '../store';
import router from '../router';
import i18n from '../assets/js/i18n';
import { BASEURL, COMEINURL } from './host';
import { REQUEST_VERSION } from '../utils/const';
import {
	getBrowser,
	getUserInfo,
	initWxMiniProgramPath,
	isCjzq,
	isEmpty,
	isFun,
	isHtzq,
	isHuatzq,
	isObject,
	isWxMiniProgram,
	isZszq,
	isZyzq,
	removeAllLineBreak,
	removeBr,
	removeUserInfo,
	replaceAllLineBreakWithBr,
	resExpHtml
} from '../utils/api';
import { getDeviceName, getSystemName } from '../utils/device';

const vue = new Vue({
	store,
	router,
	i18n
});

/**
 * *********************************************************************************
 *
 * params 说明：
 * constant_key               可选          异步请求的固定参数：'json_user_register'
 * url                        可选          异步请求地址
 * body                       可选          异步请求参数
 * method                     可选          异步请求方式(默认：POST)
 * config                     可选          异步请求配置项
 * success(res, extra)        可选          异步请求成功回调
 * error(code, desc, extra)   可选          异步请求接口成功，获取数据失败回调
 * code_xxx                   可选          覆盖全局对code=xxx的处理，需要同时给error回调
 * pending                    可选          请求是否在发送中
 * loading                    可选          是否显示转菊花（加载状态）
 * optional                   可选          可选项
 * access                      可选            兼容APP第三方调接口时accessToken
 *
 * **/

export default params => {
	// 参数 不为空 和 必须为对象格式
	if (isEmpty(params) || !isObject(params)) {
		console.log('参数错误，值为：' + params);
		return;
	}

	// if (params.pending) {
	// vue.$store.commit("fetchPending");
	// }

	if (params.loading) {
		vue.$store.dispatch('showLoading');
	}

	if (params.url && params.url.split('_') != 3) {
		params.url = COMEINURL + params.url;
	}

	// @url 支持自定义请求地址
	// 默认取 BASEURL
	isEmpty(params.url) && (params.url = BASEURL);

	// 默认给 body
	isEmpty(params.body) && (params.body = {});

	// 为 body 统一加字段
	// @b   版本号
	// @c   pc/mobile
	// @os  'web'
	// @s   浏览器信息（内核+版本）
	params.body.c = isWxMiniProgram ? 'applet' : 'h5';
	params.body.b = REQUEST_VERSION;
	params.body.sn = getSystemName();
	params.body.dn = getDeviceName();

	params.body.ua = navigator.userAgent;
	params.body.s = getBrowser().kernel + '@' + getBrowser().version;
	params.body.language = vue.$i18n.locale;
	// 兼容 旧版本回放 如果带了 type === 0，则请求头带type
	if (vue.$route.name === 'roadshow_record' && vue.$route.query.type === '0') {
		params.body.type = '0';
	}

	// 第三方 带uc
	// 如果没有不在 APP环境下，取字段给的uc
	params.body.uc = isZszq
		? 'zszq'
		: isCjzq
			? 'cjzq'
			: isHtzq
				? 'htzq'
				: isHuatzq
					? 'huataizq'
					: isZyzq
						? 'zyzq'
						: params.body.uc === undefined || params.body.uc === null
							? vue.$bridge.uc || ''
							: params.body.uc;

	// 解析以字符串形式传固定参数结构
	// @constant_key: 'json_user_register'
	if (!isEmpty(params.constant_key)) {
		const ck_array = params.constant_key.split('_');
		const constant_key_val = {
			app: ck_array[0],
			mod: ck_array[1],
			act: ck_array[2]
		};

		// 合并body
		params.body = Object.assign({}, constant_key_val, params.body);
	}
	// 接口约定 如果参数传递了uid 和 webtoken 就优先使用
	// 接口约定 默认传 uid 和 webtoken 字段，
	// 如果 用户已经登录，传有效uid和webtoken值
	// 如果没有登录，传递 空值，接口自行判断，需要登录返回201，统一处理
	if (!params.body.uid && !params.body.webtoken) {
		const userInfo = getUserInfo();
		if (userInfo) {
			params.body.uid = userInfo.uid;
			params.body.web_token = userInfo.webtoken;
			params.body.token = userInfo.webtoken;
		}
	}

	/**
	 * 如果有 userInfo
	 *  看有没有手机号码
	 *    有     就走流程
	 *    没有   就跳登录
	 *
	 * **/

	// @method 支持自定义 请求方法（GET,POST），其余转为POST（除了jsonp）
	// @body，@config 参考axios - config说明
	// https://github.com/axios/axios
	if (isEmpty(params.method) || params.method.toLowerCase() === 'post') {
		params.config = Object.assign({}, params.config, {
			headers: {
				b: REQUEST_VERSION,
				os: 'web',
				sn: getSystemName(),
				dn: getDeviceName(),
				showLoading: params.loading
			},
			transformRequest: [
				data => {
					return typeof data === 'string' ? data : Qs.stringify(data);
				}
			]
		});
		vue.$http
			.post(params.url, params.body, params.config)
			.then(s => successCallback(s, params))
			.catch(e => {
				params.networkFail ? params.networkFail(e) : errorCallback(e);
			});
	} else if (params.method.toLowerCase() === 'get') {
		vue.$store.dispatch('showLoading');
		vue.axios({
			url: params.url,
			method: 'get',
			params: params.body
		})
			.then(s => successCallback(s, params))
			.catch(e => {
				errorCallback(e);
			});
	}
};

function successCallback(res, params) {
	vue.$store.commit('fetchPendingSuccess');
	vue.$store.dispatch('hideLoading');

	// 兼容富媒体文件格式处理，
	// 如果含有标签
	//  去除 \n 保留 <br/>
	// 否则
	//  去除多余的<br/>，替换换行符\n为<br/>
	let data = JSON.stringify(res);
	res = params.keepAllLine
		? JSON.parse(data)
		: resExpHtml(data)
			? JSON.parse(removeAllLineBreak(data))
			: JSON.parse(replaceAllLineBreakWithBr(removeBr(data)));

	const code = res.errorcode;
	// @s_cb 成功回调 默认传成功时数据和extra数据
	if (!Number(code)) {
		if (params.success !== undefined) {
			if (isFun(params.success)) {
				if (typeof res.data !== 'undefined') {
					params.success(res.data, res.extra);
				} else {
					params.success(res);
				}
				return;
			}
			throw new Error('成功回调函数(success)格式错误，值为：' + params.success + ', 应该为：Function');
		}
	} else {
		// 全局处理错误情况
		// 在其他地方登陆，被迫下线
		const desc = res.errordesc;
		const extra = res.extra;
		const errorData = res.data;
		// 组件内部给error回调（错误码全局没有处理），优先处理组件内部的error回调
		// 特殊处理：全局处理错误（201/422/450）
		//    如果全局和组件内同时处理错误201
		//    在组件内给参数 code_201: true，会优先处理
		//    否则，按照全局逻辑处理
		if (
			params.error &&
			code !== '201' &&
			code !== '363' &&
			code !== '422' &&
			code !== '450' &&
			code !== '301' &&
			code !== '901' &&
			code !== '2103' &&
			code !== '1502' &&
			code !== '1512' &&
			code !== '1400' &&
			code !== '2001'
		) {
			params.error(code, desc, extra, errorData);
		} else {
			if (code === '201') {
				// 异地登录
				if (params.code_201) {
					params.error(code, desc, extra, errorData);
				} else {
					vue.$store.commit('dispatchEvent', {
						eventName: 'loginOut'
					});
					vue.$store.dispatch('handleError201');
				}
			} else if (code === '422' || code === '2001') {
				// 账号被冻结
				if (params.code_422 || params.code_2001) {
					params.error(code, desc, extra, errorData);
				} else {
					// removeUserInfo();
					vue.$store.dispatch('showDialog', {
						dialog_alert: true,
						dialog_text: desc,
						dialog_alert_data: [
							{
								btn: '确定',
								callback: () => {
									removeUserInfo();
									let isComeInMP = sessionStorage.getItem('isComeInMP');
									if (isWxMiniProgram && isComeInMP) {
										wx.miniProgram.navigateTo({
											url: initWxMiniProgramPath(isComeInMP, vue.$route.fullPath)
										});
									} else {
										vue.$router.push({ name: 'login' });
									}
								}
							}
						]
					});
				}
			} else if (code === '450') {
				// 需要绑定手机号码
				if (params.code_450) {
					params.error(code, desc, extra, errorData);
				} else {
					/* 按照产品需求：默认直接跳转到绑定页面，除非特殊说明，采用弹框方式 */
					if (isWxMiniProgram && sessionStorage.getItem('isComeInMP')) {
						wx.miniProgram.navigateTo({
							url: '/pages/bindphone/bindphone?web_path=' + encodeURIComponent(vue.$route.fullPath)
						});
					} else {
						vue.$router.push({ name: 'bind_phone' });
					}
				}
				//固定跳失败404页面
			} else if (code === '301' || code === '901' || code === '2103' || code === '1502' || code === '1512') {
				vue.$router.replace({
					name: '404',
					query: {
						'errorcode': code,
						'routername': vue.$route.name
					}
				});
			} else if (code === '1400') {
				// 已购买用户重复下单
				vue.$store.dispatch('showDialog', {
					dialog_alert: true,
					dialog_text:
						"<span style='color: #f76a2b'>" +
						getUserInfo().phonenumber +
						'</span>' +
						'&nbsp;手机账户已经购买过此内容，无需重复购买',
					dialog_alert_data: [
						{
							btn: '确定',
							callback: () => {
								vue.$router.go(-1);
							}
						}
					]
				});
			} else if (code === '8008') {
				// 专题调研活动重复报名
				if (params.code_8008) {
					params.error(code, desc, extra, errorData);
				} else {
					vue.$store.dispatch('showTooltip', {
						msg: desc
					});
				}
			} else if (code === '1005') {
				params.error && params.error(code, desc, extra, errorData);
			} else {
				vue.$store.dispatch('showTooltip', {
					msg: desc
				});
			}
		}
	}
}

function errorCallback(e_response) {
	console.log('errorCallback', e_response);
	if (e_response.errorcode == 212) {
		return;
	}
	vue.$store.commit('fetchPendingSuccess');
	vue.$store.dispatch('hideLoading');
	vue.$store.dispatch('showTooltip', '网络异常，请检查后重试');
}
